<template>
	<div class="index">
		<div class="swiper-container swiper-banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(img,index) in bannerList" :key="index">
					<img :src="img.cover" style="cursor: pointer;" class="banner_img" @click="url_link_tar(img.action)" v-if="img.actionType==300" />
						<img :src="img.cover"  class="banner_img" v-if="img.actionType==500"/>
						<img :src="img.cover"  class="banner_img" v-if="img.actionType==600"/>
					<img :src="img.cover" style="cursor: pointer;" class="banner_img" @click="url_link(img.action)" v-if="img.actionType==100"/>
					<img :src="img.cover" style="cursor: pointer;" class="banner_img" @click="url_link(img.action)" v-if="img.actionType==200"/>
				</div>
			</div>
			<div class="swiper-pagination"></div>
		</div>
		<div class="index_cont">
			<div class="article">
				<div class="title">
					<div class="title_text">
						<div class="title_img"><img src="../../assets/wbanner_1.png" alt=""></div>
						<div class="texts"><span>首席</span>文章</div>
					</div>
					<div class="title_right"><router-link to='/article' class="text-de"><img src="../../assets/arrows_right.png" alt=""></router-link></div>
				</div>
				<div class="article_cont">
					<div class="article_left">
						<!-- <div class="image"><img src="../../assets/wbanner_2.png" alt=""></div> -->
						<div class="al_list" v-for="(item,index) in wenzhang1" :key="index">
							<router-link target="_blank" :to="{path:'/council_figure',query:{id:item.id,c:item.createTime,u:item.updateTime,exp:item.expertID}}" class="text-de">
								<div class="time">{{item.yue}}<span>{{item.nian}}</span></div>
								<div class="text line2">{{item.expertInfo.name}}: {{item.title}}</div>
							</router-link>
						</div>
					</div>
					<div class="article_left">
						<!-- <div class="image"><img src="../../assets/wbanner_2.png" alt=""></div> -->
						<div class="al_list" v-for="(item,index) in wenzhang2" :key="index">
							<router-link target="_blank" :to="{path:'/council_figure',query:{id:item.id,c:item.createTime,u:item.updateTime,exp:item.expertID}}" class="text-de">
								<div class="time">{{item.yue}}<span>{{item.nian}}</span></div>
								<div class="text line2">{{item.expertInfo.name}}: {{item.title}}</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div>
				<!-- 外层的遮罩 v-if用来控制显示隐藏 点击事件用来关闭弹窗 -->
				<div class="mask" v-if="videoState == true" @click="masksCloseFun"></div>
				<!-- 弹窗 -->
				<div class="videomasks" v-if="videoState == true" >
					<div class="try" v-if="type==200">可试看3分钟，开通俱乐部会员免费看</div>
					<!-- 视频：h5的视频播放video -->
					<video :src="videoSrc" controls="controls" autoplay width="100%" height="100%" muted>
						
					</video>
				</div>
			</div>
			<div class="video_bg">
				<div class="video">
					<div class="title">
						<div class="title_text">
							<div class="title_img"><img src="../../assets/wbanner_1.png" alt=""></div>
							<div class="texts"><span>最新</span>视频</div>
						</div>
						<router-link class="title_right" to='/annual'><img src="../../assets/arrows_right.png" alt=""></router-link>
					</div>
					<div class="video_cont">
						<div class="video_list" v-for="(item,index) in videoList" :key="index"><img :src="item.cover" alt="" @click="checkVideoFun(item.url,item.videoMemberType)"></div>
					</div>
				</div>
			</div>
			<div class="member">
				<div class="title">
					<div class="title_text">
						<div class="title_img"><img src="../../assets/wbanner_1.png" alt=""></div>
						<div class="texts"><span>全体</span>理事</div>
					</div>
					<div class="title_right"><router-link to='/council' class="text-de"><img src="../../assets/arrows_right.png" alt=""></router-link></div>
				</div>
				<div class="member_swiper">
					<div class="swiper-container gallery-top">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in zhuanjia" :key="index">
								<div class="picture"><img :src="item.avator" alt=""></div>
								<div class="info">
									<div class="name">{{item.name}}</div>
									<div class="text">{{item.title}}</div>
									<div class="more"><router-link :to="{path:'/council_details',query:{id:item.id,u:item.updateTime,exp_id:item.id}}" class="text-de"><img src="../../assets/btn.png" alt=""></router-link></div>
								</div>
							</div>
						
						
						</div>
					</div>
					<div class="swiper-container gallery-thumbs">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in zhuanjia" :key="index">
								<div class="photo">
									<img :src="item.avator" alt="">
								</div>
								<div class="text">{{item.name}}</div>
							</div>
							
						</div>
					</div>
					<!-- Add Arrows -->
					<div class="swiper-button-next swiper-button-white"></div>
					<div class="swiper-button-prev swiper-button-white"></div>
				</div>
			</div>
			<div class="dynamic_bg">
				<div class="dynamic">
					<div class="title">
						<div class="title_text">
							<div class="title_img"><img src="../../assets/wbanner_1.png" alt=""></div>
							<div class="texts"><span>论坛</span>动态</div>
						</div>
						<!-- <div class="title_right"><img src="../../assets/arrows_right.png" alt=""></div> -->
					</div>
					<div class="dynamic_cont">
							<div v-for="(item,index) in dongtai" class="dy_list" :key="index">
							<router-link style="text-decoration: none;display: flex;" :to="{path:'/council_figure',query:{id:item.id,c:item.createTime,u:item.updateTime,exp:item.expertID}}" >
							
							<div class="time">
								<div class="day">{{item.nian}}<span>{{item.yue}}</span></div>
								<div class="wire"></div>
							</div>
							<div class="mine">
								<div class="text">{{item.title}}</div>
								<div class="matter" style="-webkit-box-orient: vertical;">{{item.introduction}}</div>
							</div>
							
							</router-link>
							</div>
					</div>
				</div>
			</div>
			<div class="partner_bg">
				<div class="partner">
					<div class="title">
						<div class="title_text">
							<div class="title_img"><img src="../../assets/wbanner_1.png" alt=""></div>
							<div class="texts"><span>战略</span>伙伴</div>
						</div>
					</div>
					<div class="partner_cont">
					
						<div class="partner_list"><img src="../../assets/zl1.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl2.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl3.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl4.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl5.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl6.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl7.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl8.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl9.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl10.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl11.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/zl12.jpg" alt=""></div>
						<div class="partner_list"><a href="https://www.shhzcj.com/" target="_blank"><img src="../../assets/zl14.png" alt="汇正财经"></a></div>
					</div>
				</div>
			</div>
			<div class="partner partners">
				<div class="title">
					<div class="title_text">
						<div class="title_img"><img src="../../assets/wbanner_1.png" alt=""></div>
						<div class="texts"><span>合作</span>媒体</div>
					</div>
				</div>
				<div class="partner_cont">
					<div class="partner_list"><img src="../../assets/mt1.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt2.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt3.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt4.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt5.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt6.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt7.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt8.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt9.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt10.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt11.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt12.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt13.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt14.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt15.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt16.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt17.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt18.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt19.jpg" alt=""></div>
						<div class="partner_list"><img src="../../assets/mt20.jpg" alt=""></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {encrypt,decrypt, generatekey} from "@/plugins/des2.js"
	import Swiper from 'swiper'
	import {article,ExpertAllList,NewsApi,HomeListV2,VideoTypeList} from '../../api/api.js'
	import qs from 'qs'
	import { forEach } from "core-js/es7/array"
	export default {
		name: 'home',
		components: {
			Swiper
		},
		data() {
			return {
				bannerList: [],
				videoList:[],
				wenzhang:[],
				wenzhang1:[],
				wenzhang2:[],
				zhuanjia:[],
				dongtai:[],
				videoSrc: "",
				videoState: false,
				type:100
			}
		},
	
		methods: {
			url_link(url){
				 let path=url
			     window.location.href=path
			},
			url_link_tar(url){
				
			     window.open(url)
				  
			},
			bofang() {},
			//点击按钮出现弹窗播放视频
			checkVideoFun(url,type) {
					this.videoSrc=url
				this.videoState = true
				this.type=type
			
			},
			masksCloseFun() {
				this.videoState = false;
			
			},
			//年会视频接口
			async VideoTypeList(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	type:100,
						page:1
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await VideoTypeList(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				this.video=JSON.parse(dess).d.Data
				
				for(var i=0;i<6;i++){
					this.videoList.push(this.video[i])
				}
				// console.log('=======视频=========')
				// console.log(this.videoList)
				
			},
			//banner图
			async HomeListV2(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await HomeListV2(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				this.bannerList=JSON.parse(dess).d.rotation
				// console.log('banner图nnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn')
				// console.log(this.bannerList)
			},
			//文章
			async article(){
				//加密
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	articleType:100,
				      	type:100,
				      	page:1,
				      	expertList:[]
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await article(qs.stringify(requetp))
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				this.wenzhang=JSON.parse(dess).d.Data
				
				//左侧四篇
				for(let i=0;i<5;i++){
					this.wenzhang1.push(this.wenzhang[i])
					this.wenzhang[i].yue=this.wenzhang[i].createTime.substr(5,5)
					this.wenzhang[i].nian=this.wenzhang[i].createTime.substr(0,4)
				}
				//右侧五篇
				for(let i=5;i<10;i++){
					this.wenzhang2.push(this.wenzhang[i])
					this.wenzhang[i].yue=this.wenzhang[i].createTime.substr(5,5)
					this.wenzhang[i].nian=this.wenzhang[i].createTime.substr(0,4)
				}
				console.log('文章')
				console.log(this.wenzhang)
				console.log(this.wenzhang1)
				console.log(this.wenzhang2)
			},
			
			async ExpertAllList(){
				//加密
				
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	type:-1,
				      	page:1
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await ExpertAllList(qs.stringify(requetp))	
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  	
				this.zhuanjia=JSON.parse(dess).d.Data
				// console.log('------------')
				// console.log(this.zhuanjia)
				
			},
			//动态
			async NewsApi(){
				//加密
				
				const key = localStorage.getItem('key')// generatekey(8); // 也可直接指定固定key值 let key = 'des';  
				let time = parseInt(new Date().getTime() / 1000)
				let data={
				      	token: time+"&"+localStorage.getItem('token'),
				      	os: "Web",
				      	tag:localStorage.getItem('dongtai'),
						page:1
				}
				      //如果是对象/数组的话，需要先JSON.stringify转换成字符串
				const encrypts = encrypt(JSON.stringify(data), key, key);
				let encrypts1 = encrypts.replace(/\//g,"@@");
				let encrypts2 = encrypts1.replace(/[+]/g,"$$$$");
				let requetp={
						p:encrypts2
				}	
				let res=await NewsApi(qs.stringify(requetp))	
				//解密
				let res1=res.data
				let encrypts3 = res1.replace(/@@/g, "/");
				let encrypts4 = encrypts3.replace(/\$\$/g, "+");
				const dess = decrypt(encrypts4,key,key);  
				
				let dongtai1=JSON.parse(dess).d.Data
				// console.log('动态------------------------')
				// console.log(this.dongtai)
				dongtai1.forEach((e)=>{
					e.nian=e.createTime.substr(0,4)
					e.yue=e.createTime.substr(5,5)
				})
				let dongtai2=[]
				for(var i=0;i<10;i++){
					dongtai2.push(dongtai1[i])
				}
				this.dongtai=dongtai2
				// console.log(this.dongtai)
			},
		},
	created(){
		this.article()
		this.ExpertAllList()
		this.NewsApi()
		this.HomeListV2()
		this.VideoTypeList()
	},
	watch:{
		zhuanjia:{
			handler(newval,oldval){
				this.$nextTick(()=>{
					// 下面是普通swiper模板
					// new Swiper(".swiper-banner", {
					// 	loop: true,
					// 	// mousewheel: true,
					// 	keyboard: true,
					
					// 	pagination: {
					// 		el: ".swiper-pagination",
					// 	},
					// });
					
					var galleryThumbs = new Swiper('.gallery-thumbs', {
						spaceBetween: 10,
						slidesPerView: 6,
						loop: true,
						autoplay:true,
						freeMode: true,
						loopedSlides: 5,
						watchSlidesVisibility: true,
						watchSlidesProgress: true,
					});
					// var gallerybanner = new Swiper('.swiper-banner', {
					// 	spaceBetween: 10,
					// 	slidesPerView: 1,
					// 	loop: true,
					// 	// freeMode: true,
					// 	watchSlidesVisibility: true,
					// 	watchSlidesProgress: true,
					// });
					var galleryTop = new Swiper('.gallery-top', {
						spaceBetween: 10,
						loop: true,
						autoplay:true,
						loopedSlides: 5, //looped slides should be the same
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev',
						},
						thumbs: {
							swiper: galleryThumbs,
						},
					});
				})
			}
		},
		bannerList:{
			handler(newval,oldval){
				this.$nextTick(()=>{
					// 下面是普通swiper模板
					// new Swiper(".swiper-banner", {
					// 	loop: true,
					// 	// mousewheel: true,
					// 	keyboard: true,
					
					// 	pagination: {
					// 		el: ".swiper-pagination",
					// 	},
					// });
					
					var gallerybanner = new Swiper('.swiper-banner', {
						spaceBetween: 10,
						slidesPerView: 1,
						autoplay:true,
						loop: true,
						// freeMode: true,
						// watchSlidesVisibility: true,
						// watchSlidesProgress: true,
					});
					
				})
			}
		}
	},
		beforeCreate() {
			
			
		}
	}
</script>

<style scoped>
	.index .member .member_swiper .gallery-top .text{
		width: 500px;
	}
	.try{
		position: absolute;
		    bottom: 20%;
		    left: 4%;
		    background: #8a8c8d;
		    color: #fff;
			padding: 10px;
			border-radius: 8px;
			opacity: 0.8;
			z-index: 999;
	}
	.videomasks video{
		width: 550px;object-fit: cover;
	}
	.article_cont{
		flex-wrap: nowrap;
	}
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: #000000;
		opacity: 0.6;
		z-index: 998;
	}
	.banner_img{
		height: 43vw !important;
		width: 100%;
		object-fit: cover;
	}
	
	/* 内容层 z-index要比遮罩大，否则会被遮盖 */
	.videomasks {
		max-width: 1200px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		/* transform: translate(-50%, -50%); */
	}
	
	.partner_list img{
		width: 194px;
	}
	router-link{
		text-decoration: none !important;
	}
	.line2{
		/* display: -webkit-box; */
		-webkit-box-orient: vertical;
		white-space: nowrap;
		line-clamp: 2;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		
	}
	.text-de{
		text-decoration: none;
	}
	.swiper-container .swiper-slide {
		position: relative;
	}

	.swiper-container .swiper_text {
		color: #fff;
		font-size: 40px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.swiper-container img {
		width: 100%;
		height: 100%;
	}


	.index .article {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-bottom: 70px;
		margin-top: 90px;
	}

	.index .title {
		position: relative;
		width: 15%;
	}

	.index .title .title_img {
		margin-bottom: 15px;
	}

	.index .title .texts {
		font-size: 36px;
		color: #333;
		font-weight: bold;
	}

	.index .title .title_right {
		position: absolute;
		bottom: 5px;
		left: 25%;
		bottom: 20px;
	}

	.index .title .texts span {
		color: #5082ff;
	}

	.index .article .article_cont {
		width: 81%;
		display: flex;
		justify-content: space-between;
		flex-wrap: nowrap;
		margin-top: 10px;
	}

	.index .article .article_cont .article_left {
		width: 54%;
	}

	.index .article .article_cont .article_left .image img {
		width: 100%;
		height: 100%;
		vertical-align: middle;
	}

	.index .article .article_cont .article_left .al_list {


		margin: 0 30px;
		border-bottom: 1px solid #eeeeee;
	}

	.index .article .article_cont .article_left .al_list .time {
		width: 25%;
		color: #bbbbbb;
		font-size: 26px;
	}

	.index .article .article_cont .article_left .text-de {
		text-decoration: none;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		height: 120px;
		align-items: center;
	}

	.index .article .article_cont .article_left .al_list .time span {
		font-size: 14px;
		display: block;
	}

	.index .article .article_cont .article_left .al_list .text {
		width: 75%;
		font-size: 18px;
		color: #333333;
	}

	.index .article .article_cont .article_right {
		width: 40%;
	}

	.index .article .article_cont .article_right .ar_list {
		padding: 30px 30px;
		flex-wrap: wrap;
		background-color: #fff;
		transition: 0.5s;
		margin-bottom: 22px;
	}

	.index .article .article_cont .article_right .ar_list .text {
		color: #333;
		margin-bottom: 5px;
		font-size: 1.125rem;
	}

	.index .article .article_cont .article_right .ar_list .time {
		color: #999999;
		font-size: 18px;
	}

	.index .article .article_cont .article_right .ar_list:hover {
		background-color: #5082ff;
		transition: 0.25s;
	}

	.index .article .article_cont .article_right .ar_list:hover .text {
		color: #fff;
		transition: 0.25s;
	}

	.index .article .article_cont .article_right .ar_list:hover .time {
		color: #fff;
		transition: 0.5s;
	}

	.index .video_bg {
		background-color: #f7f8fa;
		padding-top: 90px;
		padding-bottom: 80px;
	}

	.index .video {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.index .video .title_right {
		bottom: 20px;
	}

	.index .video .video_cont {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 81%;
		margin-top: 10px;
	}

	.index .video .video_cont .video_list {
		width: 31%;
		margin-bottom: 30px;
	}

	.index .video .video_cont .video_list img {
		width: 100%;
		height: 100%;
	}

	.index .member {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		margin-top: 80px;
		padding-bottom: 100px;
	}

	.index .member .title .title_right {
		bottom: 5px;
	}

	.index .member .member_swiper {
		margin-left: 8%;
		width: 73%;
		position: relative;
	}

	.index .member .member_swiper .gallery-top {
		margin-bottom: 50px;
		margin-left: 65px;
		margin-top: 10px;
		height: 200px;
	}

	.index .member .member_swiper .gallery-top .swiper-slide {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
	}

	.index .member .member_swiper .gallery-top .picture {
		margin: 0 20px;
	}

	.index .member .member_swiper .gallery-top .picture img {
		width: 160px;
		height: 160px;
		border-radius: 50%;
		object-fit: cover;
	}

	.index .member .member_swiper .gallery-top .info {
		margin: 0 20px;
	}

	.index .member .member_swiper .gallery-top .name {
		color: #5082ff;
		font-size: 24px;
		margin-bottom: 10px;
	}

	.index .member .member_swiper .gallery-top .text {
		color: #666666;
		font-size: 18px;
		margin-bottom: 50px;
	}

	.index .member .member_swiper .gallery-top .more img {
		width: 40px;
		height: 40px;
	}

	.index .member .member_swiper .gallery-thumbs .swiper-slide .photo {
		text-align: center;
	}

	.index .member .member_swiper .gallery-thumbs .swiper-slide .photo img {
		width: 85px;
		height: 85px;
		object-fit: cover;
		/* height: auto; */
		border: 1px solid #f2f2f2;
		text-align: center;
		border-radius: 50%;
		padding: 10px;
	}

	.index .member .member_swiper .gallery-thumbs .swiper-slide .text {
		text-align: center;
		color: #333333;
		font-size: 18px;
		margin-top: 15px;
	}

	.swiper-button-prev.swiper-button-white,
	.swiper-button-next.swiper-button-white {
		--swiper-navigation-color: #cccccc;
	}

	.index .member .swiper-button-next {
		position: absolute;
		bottom: 0;
		right: -40px;
		top: 77%;
	}

	.index .member .swiper-button-prev {
		position: absolute;
		bottom: 0;
		left: -40px;
		top: 77%;
	}

	.index .dynamic_bg {
		background: url("../../assets/bg.png") no-repeat center center;
		background-size: cover;
		padding: 80px 0;
	}

	.index .dynamic {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.index .dynamic .title_right {
		bottom: 20px;
	}

	.index .dynamic .dynamic_cont {
		width: 81%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 10px;
	}

	.index .dynamic .dy_list {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 42%;
		background-color: #fff;
		padding: 40px 30px 40px 30px;
		margin-bottom: 43px;
	}

	.index .dynamic .dy_list .time {
		width: auto;margin-right: 40px;
	}

	.index .dynamic .dy_list .time .day {
		font-size: 30px;
		color: #999999;
	}

	.index .dynamic .dy_list .time .day span {
		color: #999999;
		font-size: 14px;
		display: block;
	}

	.index .dynamic .dy_list .time .wire {
		border-bottom: 1px solid #eeeeee;
		width: 70px;
		margin-top: 50px;
	}

	.index .dynamic .dy_list .mine {
		width: 75%;
	}

	.index .dynamic .dy_list .mine .text {
		font-size: 20px;
		color: #666666;
		margin-bottom: 20px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.index .dynamic .dy_list .mine .matter {
		font-size: 16px;
		color: #666666;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		-webkit-box-orient: vertical !important;
	}

	.index .partner_bg {
		background-color: #fbfbfb;
		padding: 80px 0;
	}

	.index .partner {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
	}

	.index .partner_cont {
		width: 81%;
		display: flex;
		flex-wrap: wrap;
		margin-top: 5px;
	}

	.index .partner_cont .partner_list {
		width: 19.5%;
		border: 1px solid #eeeeee;
	}

	.index .partners {
		padding: 90px 0;
	}
	@media screen and (max-width: 1400px) {
		.swiper-container .swiper_text {
			font-size: 70px;
		}
	
		.index .article {
			width: 900px;
		}
	
		.index .title .texts {
			font-size: 30px;
			color: #333;
			font-weight: bold;
		}
	
		.index .article .article_cont .article_left .al_list .time {
			font-size: 20px;
		}
	
		.index .article .article_cont .article_left .al_list .text {
			font-size: 16px;
		}
	
		.index .article .article_cont .article_right .ar_list {
			padding: 25px 25px;
		}
	
		.index .article .article_cont .article_right .ar_list .text {
			font-size: 16px;
		}
	
		.index .video {
			width: 900px;
		}
	
		.index .member {
			width: 900px;
		}
	
		.index .member .member_swiper .gallery-thumbs .swiper-slide .photo img {
			width: 70px;
		}
	
		.index .member .swiper-button-next {
			top: 75%;
		}
	
		.index .member .swiper-button-prev {
			top: 75%;
		}
	
		.index .dynamic {
			width: 900px;
		}
	
		.index .dynamic .dy_list {
			width: 40%;
			padding: 20px 20px 20px 20px;
		}
	
		.index .dynamic .dy_list .time .day {
			font-size: 22px;
			color: #999999;
		}
	
		.index .partner {
			width: 900px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-items: center;
		}
	
		.index .partner_cont .partner_list img {
			width: 100%;
			height: 100%;
		}
	}
	
	@media screen and (max-width: 1000px) {
		.swiper-container .swiper_text {
			font-size: 45px;
		}
	
		.index .article {
			width: 750px;
		}
	
		.index .title {
			width: 100%;
			align-items: center;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}
	
		.index .title .title_right {
			position: sticky;
			left: 0%;
			bottom: 0px;
		}
	
		.index .article .article_cont {
			width: 100%;
			margin-top: 20px;
		}
	
		.index .video {
			width: 750px;
		}
	
		.index .video .video_cont {
			width: 100%;
			margin-top: 20px;
		}
	
		.index .member {
			width: 750px;
		}
	
		.index .member .member_swiper .gallery-top {
			margin-left: 0px;
		}
	
		.index .member .member_swiper {
			margin-left: 0%;
			margin: 0 auto;
			width: 73%;
			position: relative;
		}
	
		.index .member .member_swiper .gallery-thumbs .swiper-slide .photo img {
			width: 60px;
		}
	
		.index .member .member_swiper .gallery-top .picture {
			margin: 0px 10px;
			width: 130px;
		}
	
		.index .member .member_swiper .gallery-top .picture img {
			width: 100%;
			height: 100%;
		}
	
		.index .member .member_swiper .gallery-top .info {
			margin: 0 10px;
		}
	
		.index .dynamic {
			width: 750px;
		}
	
		.index .dynamic .dynamic_cont {
			width: 100%;
			margin-top: 20px;
		}
	
		.index .dynamic .dy_list {
			width: 43%;
			padding: 20px 20px 20px 20px;
		}
	
		.index .partner {
			width: 750px;
		}
	
		.index .partner_cont {
			width: 100%;
			margin-top: 20px;
		}
	}

	@media screen and (max-width: 768px) {
		.swiper-container .swiper_text {
			font-size: 30px;
		}
	.index .article .article_cont {
		width: 81%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 10px;
	}
		.swiper-pagination-bullet {
			width: 20px;
			height: 4px;
		}
	
		.index .article {
			width: 95%;
			margin-top: 10px;
		}
	
		.index .title .title_img {
			display: none;
		}
	
		.index .title .texts {
			font-size: 20px;
		}
	
		.index .title .title_right {
			width: 30px;
		}
	
		.index .title .title_right img {
			width: 100%;
			height: 100%;
		}
	
		.index .article .article_cont {
			margin-top: 10px;
		}
	
		.index .video_bg {
			padding-top: 10px;
			padding-bottom: 0px;
		}
	
		.index .video {
			width: 95%;
		}
	
		.index .video .video_cont .video_list {
			width: 32%;
			margin-bottom: 10px;
		}
	
		.index .video .video_cont {
			margin-top: 10px;
		}
	
		.index .member {
			width: 95%;
			margin-top: 10px;
			padding-bottom: 20px;
		}
	
		.index .member .swiper-button-next,
		.index .member .swiper-button-prev {
			display: none;
		}
	
		.index .member .member_swiper .gallery-top .picture {
			width: 90px;
		}
	
		.index .member .member_swiper .gallery-top .name {
			font-size: 18px;
			margin-bottom: 5px;
		}
	
		.index .member .member_swiper .gallery-top .text {
			font-size: 14px;
			margin-bottom: 15px;
		}
	
		.index .member .member_swiper .gallery-top .more img {
			width: 25px;
			height: 25px;
		}
	
		.index .member .member_swiper .gallery-top {
			margin-bottom: 15px;
		}
	
		.index .member .member_swiper {
			margin-left: 0%;
			margin: 0 auto;
			width: 74%;
			position: relative;
		}
	
		.index .dynamic_bg {
			padding: 10px 0;
		}
	
		.index .dynamic .dynamic_cont {
			width: 100%;
			margin-top: 10px;
		}
	
		.index .dynamic .dy_list {
			width: 100%;
			padding: 10px;
			margin-bottom: 10px;
			align-items: center;
		}
	
		.index .dynamic .dy_list .time .wire {
			display: none;
		}
	
		.index .dynamic .dy_list .mine .text {
			font-size: 16px;
			margin-bottom: 10px;
		}
	
		.index .dynamic .dy_list .mine .matter {
			font-size: 14px;
		}
	
		.index .dynamic .dy_list .mine .matter p {
			margin: 0;
		}
	
		.index .dynamic .dy_list .time {
			width: 65px;
		}
	
		.index .dynamic {
			width: 95%;
		}
	
		.index .dynamic .dy_list .mine {
			width: 85%;
		}
	
		.index .partner_bg {
			background-color: #fbfbfb;
			padding: 10px 0;
		}
	
		.index .partner {
			width: 95%;
		}
	
		.index .partners {
			padding: 10px 0;
		}
	
		.index .article .article_cont .article_left {
			width: 100%;
		}
	
		.index .article .article_cont .article_right {
			width: 100%;
			margin-top: 10px;
		}
	
		.index .article .article_cont .article_left .al_list {
			margin: 0 10px;
		}
	
		.index .article .article_cont .article_left .text-de {
			height: 100px;
		}
	
		.index .article .article_cont .article_left .al_list .time {
			width: 15%;
			font-size: 18px;
		}
	
		.index .article .article_cont .article_left .al_list .text {
			width: 80%;
			font-size: 16px;
		}
	
		.index .article .article_cont .article_right .ar_list {
			padding: 15px;
			margin-bottom: 10px;
		}
	
		.index .article {
			padding-bottom: 10px;
			margin-top: 60px;
		}
	
		.index .member .member_swiper {
			margin-left: 0%;
			margin: 0 auto;
			width: 99%;
			position: relative;
			overflow: hidden;
		}
	
		.swiper-container {
			margin-top: 10px;
		}
	}
	
	@media screen and (max-width: 520px) {
		.index .member .member_swiper .gallery-thumbs .swiper-slide .photo img {
			width: 50px;
			padding: 0px;
		}
	
		.index .member .member_swiper .gallery-thumbs .swiper-slide .text {
			font-size: 13px;
			margin-top: 0px;
		}
	
		.swiper-container .swiper_text {
			font-size: 18px;
		}
	
		.swiper-pagination-bullet {
			width: 23px;
			height: 3px;
		}
	
		.index .title .texts {
			font-size: 18px;
		}
	
		.index .article .article_cont {
			margin-top: 5px;
		}
	
		.index .title .title_right {
			width: 25px;
		}
	
		.index .article .article_cont .article_left .al_list .text {
			width: 80%;
			font-size: 14px;
		}
	
		.index .article .article_cont .article_left .al_list .time {
			width: 15%;
			font-size: 16px;
		}
	
		.index .article .article_cont .article_left .text-de {
			height: 75px;
		}
	
		.index .article .article_cont .article_right .ar_list {
			padding: 10px;
			margin-bottom: 0px;
		}
	
		.index .article .article_cont .article_right .ar_list .text {
			font-size: 14px;
		}
	
		.index .article .article_cont .article_right .ar_list .time {
			font-size: 16px;
		}
	
		.index .video .video_cont .video_list {
			width: 49%;
			margin-bottom: 7px;
		}
	
		.index .video .video_cont {
			margin-top: 5px;
		}
	
		.index .member .member_swiper .gallery-top .picture {
			width: 75px;
		}
	
		.index .member .member_swiper .gallery-top .info {
			width: 50%;
		}
	
		.index .member .member_swiper .gallery-top .name {
			font-size: 16px;
			margin-bottom: 5px;
		}
	
		.index .member .member_swiper .gallery-top .text {
			font-size: 12px;
			margin-bottom: 7px;
		}
	
		.index .dynamic .dy_list .time {
			display: none;
		}
	
		.index .dynamic .dy_list .mine {
			width: 100%;
		}
	
		.index .dynamic .dy_list .mine .text {
			font-size: 14px;
			margin-bottom: 3px;
			font-weight: bold;
		}
	
		.index .dynamic .dy_list .mine .matter {
			font-size: 12px;
		}
	
		.index .partner_cont {
			width: 100%;
			margin-top: 10px;
		}
	
		.index .partner_cont .partner_list {
			width: 32.6%;
			border: 1px solid #eeeeee;
		}
	}
</style>
